import { CommonModule, DOCUMENT } from "@angular/common";
import {
  Component,
  ElementRef,
  HostBinding,
  Inject,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import { NgbCollapseModule } from "@ng-bootstrap/ng-bootstrap";
import { AppPaths } from "projects/assist/src/app/app-routes";
import { AccountingPaths } from "projects/assist/src/app/accounting/accounting-routes";
import { Federations } from "projects/assist/src/app/organisation/models/federation";
import { SubscriptionService } from "projects/assist/src/app/organisation/services/subscription.service";
import { SettingsPaths } from "projects/assist/src/app/settings/settings-routes";
import { StartSettingSmallOrgDto } from "../../../../organisation/models/startsetting";
import { StartsettingsService } from "../../../../organisation/services/startsettings.service";
import { GlobalVariables } from "../../../services/global.service";
import { createRoutePath } from "../../../utils/route-util";
import { MenuItem } from "./models/menuItem";

@Component({
  selector: "app-sidenav",
  templateUrl: "./sidenav.component.html",
  styleUrls: ["./sidenav.component.scss"],
  standalone: true,
  imports: [CommonModule, RouterModule, NgbCollapseModule],
})
export class SidenavComponent implements OnInit, OnChanges {
  @Input() menuItems: MenuItem[] = [];
  global = GlobalVariables;
  federations = Federations;
  showOldAssist: boolean = false;
  @Input() mijnAssist: boolean = false;
  @HostBinding("class.mijn-assist") get isMijnAssist(): boolean {
    return this.mijnAssist;
  }
  startSetting: StartSettingSmallOrgDto | null = null;
  hasVat = false;
  vatTypeId: number | null = null;
  federationid: number | null = null;
  subscriptionTypeId: number | null = null;
  constructor(
    private el: ElementRef,
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    public subscriptionService: SubscriptionService,
    private startsettingservice: StartsettingsService
  ) {}

  ngOnInit(): void {
    if (!this.mijnAssist)
      this.startsettingservice.getCurrent().subscribe((x) => {
        this.startSetting = x;
        if (this.startSetting != null && this.startSetting?.VatTypeId != null) {
          this.hasVat = this.startSetting.VatTypeId >= 1 && this.startSetting.VatTypeId != 5;
          this.vatTypeId = this.startSetting.VatTypeId;
        }
        this.federationid = this.startSetting?.Organization?.FederationId;
        this.updatePeppolMenuItems();
      });

    if (!this.mijnAssist)
      this.subscriptionService.getCurrent().subscribe((subscription) => {
        this.showOldAssist = subscription.SubscriptionTypeId != 5;
        this.subscriptionTypeId = subscription.SubscriptionTypeId;
      });

    this.initCollapsed();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["menuItems"]) {
      this.initCollapsed();
    }
  }

  private initCollapsed(): void {
    this.menuItems.forEach((menuItem) => {
      if (menuItem.collapsed === undefined) {
        menuItem.collapsed = true;
      }
    });
  }

  toggleSidenav() {
    const sidenav = this.el.nativeElement.querySelector("#sidenav-main");
    const iconSidenav = this.el.nativeElement.querySelector("#iconSidenav");
    const body = this.document.body;
    const className = "g-sidenav-pinned";

    if (body.classList.contains(className)) {
      body.classList.remove(className);
      setTimeout(function () {
        sidenav.classList.remove("bg-white");
      }, 100);
      sidenav.classList.remove("bg-transparent");
    } else {
      body.classList.add(className);
      sidenav.classList.add("bg-white");
      sidenav.classList.remove("bg-transparent");
      iconSidenav.classList.remove("d-none");
    }
  }

  sidenavToggler() {
    let sidenavToggler = this.document.getElementsByClassName("sidenav-toggler")[0];
    let sidenavShow = this.document.getElementsByClassName("g-sidenav-show")[0];
    let toggleNavbarMinimize = this.document.getElementById("navbarMinimize");

    if (!sidenavShow.classList.contains("g-sidenav-hidden")) {
      sidenavShow.classList.remove("g-sidenav-pinned");
      sidenavShow.classList.add("g-sidenav-hidden");
      if (toggleNavbarMinimize) {
        toggleNavbarMinimize.click();
        toggleNavbarMinimize.setAttribute("checked", "true");
      }
    } else {
      sidenavShow.classList.remove("g-sidenav-hidden");
      sidenavShow.classList.add("g-sidenav-pinned");
      if (toggleNavbarMinimize) {
        toggleNavbarMinimize.click();
        toggleNavbarMinimize.removeAttribute("checked");
      }
    }
  }

  navigate(url: string | undefined) {
    if (url) this.router.navigateByUrl(createRoutePath([url]));
  }

  closeOnMobile() {
    let sidenavShow = this.document.getElementsByClassName("g-sidenav-show")[0];
    if (window) {
      if (window.innerWidth < 1200) {
        this.sidenavToggler();
      }
    }
  }

  navigateOnToggle(item: MenuItem) {
    const collapsed = item.collapsed ?? true;
    const url = !collapsed ? null : item.route;
    if (url) this.router.navigateByUrl(createRoutePath([url]));
    item.collapsed = !collapsed;
  }

  private updatePeppolMenuItems(): void {
    const hasPeppol = !!this.startSetting?.Organization?.PeppolId;
    const peppolRoute = hasPeppol
      ? createRoutePath([AppPaths.Accounting, AccountingPaths.PeppolInbox])
      : createRoutePath([AppPaths.Accounting, AccountingPaths.PeppolStart]);
    const peppolName = hasPeppol ? "Peppol-inbox" : "Peppol activeren";

    for (const item of this.menuItems) {
      if (!item.subItems) continue;
      let peppolFound = false;
      item.subItems = item.subItems.filter((sub) => {
        if (sub.route?.includes("peppolinbox") || sub.route?.includes("peppol-start")) {
          if (peppolFound) return false;
          peppolFound = true;
          sub.name = peppolName;
          sub.route = peppolRoute;
        }
        return true;
      });
    }
  }

  getFilteredSubItems(item: MenuItem): MenuItem[] {
    if (!item.subItems) return [];
    if (this.vatTypeId == null) return item.subItems;
    return item.subItems.filter(
      (child) => !child.vatTypeIds || child.vatTypeIds.includes(this.vatTypeId!)
    );
  }

  createSettingsUrl() {
    return createRoutePath([AppPaths.Settings, SettingsPaths.Settings]);
  }
}
